import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useState, useEffect } from "react";

const testimonials = [
  {
    name: "عبدالله المالكي",
    role: "صاحب فيلا — الرياض",
    text: "تجربة استثنائية من البداية إلى النهاية. التصميم الداخلي فاق توقعاتنا والتنفيذ كان بجودة عالية جداً. أنصح بهم بشدة.",
    rating: 5,
  },
  {
    name: "فهد العتيبي",
    role: "مدير مشاريع — شركة عقارية",
    text: "تعاملنا معهم في ترميم مبنى تجاري وكانت النتائج مبهرة. التزام بالمواعيد وجودة في التنفيذ واحترافية في التعامل.",
    rating: 5,
  },
  {
    name: "سارة الدوسري",
    role: "مصممة ديكور",
    text: "فريق عمل متميز ومتعاون. نفذوا التصميم بدقة متناهية وأضافوا لمسات إبداعية رائعة. شراكة ناجحة ومستمرة.",
    rating: 5,
  },
  {
    name: "محمد الشمري",
    role: "صاحب شقة — الرياض",
    text: "أعمال الدهانات وورق الجدران كانت ممتازة. الألوان نابضة بالحياة والتشطيب نظيف جداً. سعر مناسب وخدمة ممتازة.",
    rating: 5,
  },
];

const TestimonialsSection = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="section-padding charcoal-gradient">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="w-12 h-0.5 gold-gradient mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-marble mb-4">آراء عملائنا</h2>
          <p className="text-marble/70 max-w-lg mx-auto">ثقة عملائنا هي أغلى ما نملك</p>
        </motion.div>

        <div className="max-w-3xl mx-auto relative overflow-hidden min-h-[320px] sm:min-h-[280px] px-2">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={false}
              animate={{
                opacity: i === current ? 1 : 0,
                x: i === current ? 0 : i > current ? 80 : -80,
              }}
              transition={{ duration: 0.5 }}
              className={`absolute inset-0 flex flex-col items-center text-center ${i === current ? "pointer-events-auto" : "pointer-events-none"}`}
            >
              <Quote className="w-10 h-10 text-primary/30 mb-6" />
              <p className="text-marble text-base sm:text-lg md:text-xl leading-relaxed mb-6 sm:mb-8 max-w-2xl">
                "{t.text}"
              </p>
              <div className="flex gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              <h4 className="text-marble font-bold text-lg">{t.name}</h4>
              <span className="text-marble/60 text-sm">{t.role}</span>
            </motion.div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all ${i === current ? "bg-primary w-8" : "bg-marble/30"}`}
              aria-label={`شهادة ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
